import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Box, Button, Divider, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import PageHeader from '../../../components/page-header';
import { useBudgetProgramCreateEditController } from './context/budget-program-create-edit-controller';
import { useBudgetProgramCreateEditState } from './context/budget-program-create-edit-context';

export function BudgetProgramCreateEditComponent() {
    const { handleOnChange, handleSave, handleCancel, isSaving } = useBudgetProgramCreateEditController();
    const { budgetProgramRequest, budgetUnits, showValidationErrors, budgetProgramId } = useBudgetProgramCreateEditState();
    const isEdit = !!budgetProgramId;

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title={isEdit ? 'Editar Programa Orçamentário' : 'Novo Programa Orçamentário'}
                    subtitle={isEdit ? 'Atualize as informações do programa orçamentário' : 'Cadastre um novo programa orçamentário no sistema'}
                    breadcrumbs={[{ label: 'Programas Orçamentários', href: '/programas-orcamentarios' }, { label: isEdit ? 'Editar' : 'Novo' }]}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column' }} elevation={3}>
                    <Grid container spacing={3}>

                        {/* Identificação */}
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
                                Identificação
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <InputLabel required>Código</InputLabel>
                            <OutlinedInput
                                fullWidth
                                autoComplete="off"
                                name="code"
                                value={budgetProgramRequest.code || ''}
                                onChange={handleOnChange}
                                error={showValidationErrors && !budgetProgramRequest.code}
                            />
                            {showValidationErrors && !budgetProgramRequest.code && (
                                <FormHelperText error>Código é obrigatório</FormHelperText>
                            )}
                        </Grid>

                        <Grid item xs={12} md={8}>
                            <InputLabel required>Nome</InputLabel>
                            <OutlinedInput
                                fullWidth
                                autoComplete="off"
                                name="name"
                                value={budgetProgramRequest.name || ''}
                                onChange={handleOnChange}
                                error={showValidationErrors && !budgetProgramRequest.name}
                            />
                            {showValidationErrors && !budgetProgramRequest.name && (
                                <FormHelperText error>Nome é obrigatório</FormHelperText>
                            )}
                        </Grid>

                        {/* Vinculação */}
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ mb: 2, mt: 1, color: 'primary.main', fontWeight: 600 }}>
                                Vinculação
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <InputLabel required>Unidade Orçamentária</InputLabel>
                            <Select
                                fullWidth
                                name="budgetUnitId"
                                disabled={isEdit}
                                value={budgetProgramRequest.budgetUnitId ?? ''}
                                onChange={handleOnChange}
                                error={showValidationErrors && !budgetProgramRequest.budgetUnitId}
                            >
                                <MenuItem value=""><em>Selecionar</em></MenuItem>
                                {budgetUnits.map((u) => <MenuItem key={u.id} value={u.id}>{u.code} - {u.name}</MenuItem>)}
                            </Select>
                            {showValidationErrors && !budgetProgramRequest.budgetUnitId && (
                                <FormHelperText error>Unidade Orçamentária é obrigatória</FormHelperText>
                            )}
                        </Grid>

                        {/* Ações */}
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, mt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
                                <Box sx={{ flex: '1 1 auto' }} />
                                <Button
                                    variant="outlined"
                                    startIcon={<CancelIcon />}
                                    onClick={handleCancel}
                                    sx={{ mr: 1 }}
                                >
                                    Cancelar
                                </Button>
                                <LoadingButton
                                    variant="contained"
                                    startIcon={<SaveIcon />}
                                    onClick={handleSave}
                                    loading={isSaving}
                                    disabled={isSaving}
                                >
                                    Salvar
                                </LoadingButton>
                            </Box>
                        </Grid>

                    </Grid>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
